<template>
  <q-card class="rounded-xl border border-neutral-100/10 shadow-sm">
    <div class="flex items-center justify-between p-24 md2:p-16">
      <TextIcon
        icon="svguse:#icon_pie_chart"
        text="Resultado por Pilar"
        icon-class="text-primary-pure"
        div-class="!gap-12 !font-normal min-h-48"
      />

      <div
        class="flex items-center gap-16"
        data-export-ignore
      >
        <q-spinner-tail
          v-if="pilarResultsLoading && pilarResults.length"
          color="primary"
          size="1.5rem"
        />

        <OButton
          size="lg"
          class="w-48 h-48 !bg-[#EFEFEF] text-neutral-70 !border-none"
          tertiary
          icon="download"
          :loading="exporting"
          :disable="!pilarResults.length"
          @click="$emit('download')"
        >
          <q-tooltip> Baixar </q-tooltip>
        </OButton>
      </div>
    </div>

    <div
      class="grid gap-16 px-24 pb-24 xl:!grid-cols-3 md:!grid-cols-2 sm:!grid-cols-1 md2:px-16 md2:pb-16"
      :style="`grid-template-columns: repeat(${columns}, minmax(0, 1fr));`"
    >
      <template v-if="pilarResultsLoading && !pilarResults.length">
        <q-skeleton
          v-for="n in 5"
          :key="n"
          type="rect"
          class="rounded-xl h-[10.5rem]"
        />
      </template>

      <template v-else>
        <CardPilarResult
          v-for="(pilar, index) in pilarResults"
          :key="pilar.id"
          :pilar="pilar"
          :index="index"
        />
      </template>
    </div>
  </q-card>
</template>

<script setup>
import OButton from 'components/Button/OButton.vue'
import TextIcon from 'components/Text/TextIcon.vue'
import CardPilarResult from './CardPilarResult.vue'
import { pilarResults, pilarResultsLoading } from 'store/copa.stores'
import { computed } from 'vue'

defineProps({
  exporting: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['download'])

const columns = computed(() => pilarResults.value.length || 5)
</script>
